<template>
    <div class="content">
        <div class="container-fluid">
          <div class="row align-items-center mb-1">
            <div class="col-md-6">
              <div class="h2">Messages</div>
            </div>
            <div class="col-md-3 offset-md-3 text-right center">
              <button type="submit" class="btn btn-primary btn-fill" @click="createMessage">Create Message</button>
            </div>
          </div>
            <!--<div class="row align-items-center mb-1">-->
                <!--<div class="col-md-6">-->
                    <!--<div class="h2">Greetings Board</div>-->
                <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                <!--<button type="submit" class="btn btn-primary btn-fill" @click="createGreeting">Create Greeting</button>-->
              <!--</div>-->
              <!--<div class="col-md-2 offset-md-2 text-right center">-->
                    <!--<button type="button" class="btn btn-primary btn-fill" @click="$router.push({ name: 'Greeting Ordering'})">Order Greeting</button>-->
                <!--</div>-->
            <!--</div>-->
            <div class="table-responsive text-center">
                <l-table class="table table-light  table-light table-bordered table-hover"
                         :columns="messages.columns" :data="messages.data">
                    <template slot="table-row" v-if="messages.data.length">
                        <tr v-for="(item, index) in messages.data" :key="index" :class="{'inactive': item.status === '0'}">
                            <td>{{item.greetingId}}</td>
                            <td>{{item.greeting}}</td>
                            <td>{{item.corporationName}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewMessage(item)" v-tooltip.top-center="messages.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editMessage(item)" v-tooltip.top-center="messages.tooltips.edit"><i class="fa fa-edit"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const messagesColumns = ['Message Id', 'Message', 'Corporations', 'Status', 'Operations'];
    export default {
        name: 'messages',
        components: {
            LTable,
        },
        data() {
        return {
          messages: {
                tooltips: {
                    view: 'View Message',
                    edit: 'Edit Message',
                    delete: 'Inactivate Message',
                    activate:'Activate Message',
                },
                columns: [...messagesColumns],
        tableRowClass: {
            classname: 'badge-warning',
                    classActiveCondition: 'status'
        },
        data: []
    }
    }
    },
    methods: {
        fetchMessages () {
            this.$store.dispatch('FETCH_MESSAGES')
                    .then((res) => {
                        this.messages.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewMessage(message){
            this.$router.push({ name: 'MessageDetail', params: { id: message.greetingId}})
        },
        editMessage(message){
            this.$router.push({ name: 'EditMessage', params: { id: message.greetingId}})
        },
        createMessage(){
            this.$router.push({ name: 'CreateMessage'})
        },
        deleteTestimonial(testimonial, boolean){
            console.log("testimonial : ", testimonial);
            this.$store.dispatch('DELETE_SELECTED_TESTIMONIAL', {testimonialId: testimonial.pkCarouselId})
                    .then((res) => {
                        console.log("DELETE_SELECTED_EXPERT API res : ", res);
                        this.fetchTestimonials();
                    })
                    .catch(err => {
                        console.log("DELETE_SELECTED_EXPERT API error : ", err);
                    })
        }
    },
    created() {
        this.fetchMessages();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Messages/Messages.vue